import store from "@/core/services/store";
import { CHANGE_MENUS } from "@/core/services/store/auth";
/**
 * 深拷贝
 * @param {*} obj 拷贝对象(object or array)
 * @param {*} cache 缓存数组
 */
export const deepCopy = (obj, cache = []) => {
  // typeof [] => 'object'
  // typeof {} => 'object'
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  const hit = cache.filter(c => c.original === obj)[0]
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
  cache.push({
    original: obj,
    copy
  })
  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}
export const addLeftMenu = (clientId, claaBack) => {
  store.dispatch(CHANGE_MENUS, clientId).then((leftMenus) => {
    let routers = generateRouters(leftMenus);
    if (typeof claaBack === "function") {
      claaBack(routers, leftMenus);
    }
  })
}
export const generateRouters = (data) => {
  let left = [{
    path: "/",
    component: resolve => require(['@/view/layout/Layout.vue'], resolve),
    children: generateChildRouters(data)
  }, {
    path: "/",
    component: resolve => require(['@/view/pages/auth/Auth'], resolve),
    children: [
      {
        name: "login",
        path: "/login",
        component: resolve => require(['@/view/pages/auth/Login'], resolve)
      },
      {
        name: "register",
        path: "/register",
        component: () => resolve => require(['@/view/pages/auth/Register'], resolve)
      }
    ]
  }, {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: resolve => require(['@/view/pages/error/Error-1.vue'], resolve)
  }]
  return left
}
export const generateChildRouters = (data, propName) => {
  const routers = [];
  data.forEach((item) => {
    let componentPath;
    componentPath = resolve => require(['@/view/' + item.component + '.vue'], resolve)
    let menu = {
      path: item.url,
      name: item.name,
      meta: {
        propName
      },
      component: componentPath,
    }
    if (item.children && item.children.length > 0) {
      menu.children = [...generateChildRouters(item.children, propName || item.name)];
    }
    //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    //判断是否生成路由
    if (item.route && item.route === '0') {
      //console.log(' 不生成路由 item.route：  '+item.route);
      //console.log(' 不生成路由 item.path：  '+item.path);
    } else {
      routers.push(menu);
    }
  })
  return routers
}
export const getDate = (o, type = '/') => { // 获取当前年月日
  var date = new Date(o); var year = date.getFullYear(); var mone = date.getMonth(); var data = date.getDate();
  return `${year}${type}${mone < 9 ? `0${mone + 1}` : mone + 1}${type}${data < 10 ? `0${data}` : data}`;
};
export const getMM = (o, type = ':') => { // 获取当前时分秒
  var date = new Date(o); var hours = date.getHours(); var minutes = date.getMinutes(); var seconds = date.getSeconds();
  return `${hours < 10 ? `0${hours}` : hours}${type}${minutes < 10 ? `0${minutes}` : minutes}${type}${seconds < 10 ? `0${seconds}` : seconds}`;
};